import { useState } from 'react';
import { api } from '../shared/api.ts';
import { Library } from './Library.tsx';

export function Push({
  selection,
  onSelectionChange,
  refreshKey,
}: {
  selection: Set<string>;
  onSelectionChange: (next: Set<string>) => void;
  refreshKey: number;
}): React.JSX.Element {
  const [code, setCode] = useState('');
  const [status, setStatus] = useState<{ kind: 'ok' | 'error'; text: string } | null>(null);
  const [busy, setBusy] = useState(false);

  const send = async (): Promise<void> => {
    setBusy(true);
    setStatus(null);
    try {
      const result = await api.push(code.trim(), [...selection]);
      setStatus({
        kind: 'ok',
        text: `Sent ${result.count} ${result.count === 1 ? 'file' : 'files'}.`,
      });
      onSelectionChange(new Set());
    } catch (err) {
      setStatus({ kind: 'error', text: err instanceof Error ? err.message : 'Push failed' });
    } finally {
      setBusy(false);
    }
  };

  const ready = code.trim().split('-').filter(Boolean).length === 3 && selection.size > 0;

  return (
    <div className="pane">
      <div className="push__head">
        <input
          className="input push__code mono"
          type="text"
          inputMode="text"
          autoCapitalize="none"
          autoCorrect="off"
          spellCheck={false}
          placeholder="three-word-code"
          value={code}
          onChange={(e) => setCode(e.target.value)}
        />
        <button
          type="button"
          className="button button--primary"
          onClick={() => void send()}
          disabled={!ready || busy}
        >
          {busy ? 'Sending…' : `Push ${selection.size || ''}`.trim()}
        </button>
      </div>

      {status ? (
        <p className={`push__status mono${status.kind === 'error' ? ' is-error' : ''}`}>{status.text}</p>
      ) : null}

      <Library selection={selection} onSelectionChange={onSelectionChange} refreshKey={refreshKey} />
    </div>
  );
}
